'use strict'
import { request } from '../../plugins/http'

export default async (type, param) => {
    return await request.get('/idioma', {params:{type, param}})
}